import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

import {
  StorageCheckinPage,
  StorageCheckoutPage,
  StorageDashboardPage,
  StorageListingPage,
  StorageSupplyPage,
  StorageTransferPage,
} from '../../features/estoque'

export default function Component() {
  return (
    <Routes>
      <Route index element={<StorageListingPage />} />
      {/* <Route path="novo" element={<Person.Create />} /> */}
      <Route path=":storage_id" element={<Outlet />}>
        <Route index element={<StorageDashboardPage />} />
        <Route path="itens" element={<Outlet />}>
          <Route index element={<Navigate to="../" />} />
          <Route path="abastecer" element={<StorageSupplyPage />} />
          <Route path="transferir" element={<StorageTransferPage />} />
          <Route path="retirar" element={<StorageCheckoutPage />} />
          <Route path="devolver" element={<StorageCheckinPage />} />
        </Route>
      </Route>
    </Routes>
  )
}
